import * as React from "react";

type MansionProps = {
  fillColor?: string;
  height?: string;
  width?: string;
};

const Mansion = ({ fillColor = "#231815", width = "49.411", height = "38.234" }: MansionProps) => {
  return (
    <svg id="mansion" xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 49.411 38.234">
      <g id="グループ_2238" data-name="グループ 2238">
        <path
          id="パス_2302"
          data-name="パス 2302"
          d="M47.911,35.234H42.346V1.5a1.5,1.5,0,0,0-1.5-1.5H8.565a1.5,1.5,0,0,0-1.5,1.5V35.234H1.5a1.5,1.5,0,0,0,0,3H47.911a1.5,1.5,0,0,0,0-3ZM10.065,3h29.28V35.234h-4.1V25.872a1.5,1.5,0,0,0-1.5-1.5H26.3a1.5,1.5,0,0,0-1.5,1.5v9.362H10.065ZM32.248,35.234H27.8V27.372h4.45Z"
          fill={fillColor}
        />
        <path
          id="パス_2303"
          data-name="パス 2303"
          d="M15.6,11.7h3.677a1.655,1.655,0,1,0,0-3.31H15.6a1.655,1.655,0,1,0,0,3.31Z"
          fill={fillColor}
        />
        <path
          id="パス_2304"
          data-name="パス 2304"
          d="M19.278,14.927H15.6a1.655,1.655,0,0,0,0,3.31h3.677a1.655,1.655,0,1,0,0-3.31Z"
          fill={fillColor}
        />
        <path
          id="パス_2305"
          data-name="パス 2305"
          d="M26.457,18.236h3.677a1.655,1.655,0,1,0,0-3.31H26.457a1.655,1.655,0,1,0,0,3.31Z"
          fill={fillColor}
        />
        <path
          id="パス_2306"
          data-name="パス 2306"
          d="M26.457,11.7h3.677a1.655,1.655,0,1,0,0-3.31H26.457a1.655,1.655,0,1,0,0,3.31Z"
          fill={fillColor}
        />
      </g>
    </svg>
  );
};

export default Mansion;
